export default __webpack_public_path__ + "12efc0adf95d09aef11d89a344e7ccab.png";